import React, { useEffect, useState } from 'react';
import usePostApi from '../../utils/usePostApi';

export default function ScheduleVerifyToolbar({ schedule }) {
  // don't show anything if nothing to verify
  if (!schedule.pdf_link && !schedule.data) return null;

  return (
    <div className="well" key={schedule.modified}>
      {schedule.pdf_link && <VerifiedToolItem schedule={schedule} type={'pdf'} />}
      <span style={{ marginLeft: 32 }}></span>
      {schedule.data && <VerifiedToolItem schedule={schedule} type={'data'} />}
    </div>
  );
}

function VerifiedToolItem({ schedule, type }) {
  const [{ data, isLoading, isError }, updateVerifiedStatus] = usePostApi('/scheduleform/set-verified');

  const setting_name = `is_${type}_verified`;
  const [isVerified, setIsVerified] = useState(schedule[setting_name]);
  function toggleVerified() {
    console.log(
      `Setting ${schedule.case_uuid} ${schedule.schedule_type} ${setting_name} to ${!isVerified ? 'true' : 'false'}`
    );
    updateVerifiedStatus({
      case_uuid: schedule.case_uuid,
      type: schedule.schedule_type,
      verified_field: setting_name,
      value: !isVerified,
    });
  }

  useEffect(() => {
    if (!data) return;
    console.log('Got new schedule form data', data);
    setIsVerified(!isVerified);
    refresh_menu(schedule.case_uuid);
  }, [data]);

  useEffect(() => {
    if (!isError) return;
    const message =
      `Error setting ${schedule.case_uuid} ${schedule.schedule_type} ${setting_name} to ` +
      (!isVerified ? 'Yes' : 'No');
    console.error(message, isError);
    alert(message + '\n' + isError);
  }, [isError]);

  return (
    <React.Fragment>
      <span style={{ fontSize: 18, verticalAlign: 'middle' }}>
        {type.toUpperCase()} Verified{' '}
        <span style={{ color: isVerified ? 'green' : 'red', fontWeight: 'bold' }}>{isVerified ? 'Yes' : 'No'}</span>{' '}
      </span>
      <button
        className={`btn btn-${isVerified ? 'secondary' : 'success'}`}
        onClick={toggleVerified}
        disabled={isLoading}
      >
        {isLoading ? 'Marking ...' : isVerified ? 'Mark Unverified' : 'Mark Verified'}
      </button>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/common/ScheduleVeriyToolbar.jsx